import { render } from "./GibergLJewellery.vue?vue&type=template&id=f70d23a0&scoped=true"
import script from "./GibergLJewellery.vue?vue&type=script&lang=js"
export * from "./GibergLJewellery.vue?vue&type=script&lang=js"

import "./GibergLJewellery.vue?vue&type=style&index=0&id=f70d23a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70d23a0"]])

export default __exports__